/* Code generated by "enumer -linecomment -type=EventType -parseError=ErrWebhookInvalidEventType -ts=../../../frontend/apps/dashboard/src/if/event/EventType.ts"; DO NOT EDIT. */

export enum EventType {
  EvtACHOutgoingTransferPreReview = 'ach.outgoing_transfer.pre_review',
  EvtACHOutgoingTransferInitiated = 'ach.outgoing_transfer.initiated',
  EvtACHOutgoingTransferSubmitted = 'ach.outgoing_transfer.submitted',
  EvtACHOutgoingTransferSettled = 'ach.outgoing_transfer.settled',
  EvtACHOutgoingTransferCompleted = 'ach.outgoing_transfer.completed',
  EvtACHOutgoingTransferManualReview = 'ach.outgoing_transfer.manual_review',
  EvtACHOutgoingTransferReturned = 'ach.outgoing_transfer.returned',
  EvtACHOutgoingTransferCanceled = 'ach.outgoing_transfer.canceled',
  EvtACHOutgoingTransferReturnDishonored = 'ach.outgoing_transfer.return_dishonored',
  EvtACHOutgoingTransferReturnDishonoredFundsUnlocked = 'ach.outgoing_transfer.return_dishonored_funds_unlocked',
  EvtACHOutgoingTransferReturnContested = 'ach.outgoing_transfer.return_contested',
  EvtACHOutgoingTransferNOC = 'ach.outgoing_transfer.noc',
  EvtACHIncomingTransferSettled = 'ach.incoming_transfer.settled',
  EvtACHIncomingTransferCompleted = 'ach.incoming_transfer.completed',
  EvtACHIncomingTransferNSF = 'ach.incoming_transfer.nsf',
  EvtACHIncomingTransferReturned = 'ach.incoming_transfer.returned',
  EvtACHIncomingTransferScheduled = 'ach.incoming_transfer.scheduled',
  EvtACHIncomingTransferReturnDishonored = 'ach.incoming_transfer.return_dishonored',
  EvtACHIncomingTransferReturnContested = 'ach.incoming_transfer.return_contested',
  EvtWireOutgoingTransferPreReview = 'wire.outgoing_transfer.pre_review',
  EvtWireOutgoingTransferInitiated = 'wire.outgoing_transfer.initiated',
  EvtWireOutgoingTransferSubmitted = 'wire.outgoing_transfer.submitted',
  EvtWireOutgoingTransferRejected = 'wire.outgoing_transfer.rejected',
  EvtWireOutgoingTransferCompleted = 'wire.outgoing_transfer.completed',
  EvtWireIncomingTransferCompleted = 'wire.incoming_transfer.completed',
  EvtWireIncomingTransferRejected = 'wire.incoming_transfer.rejected',
  EvtWireOutgoingTransferManualReview = 'wire.outgoing_transfer.manual_review',
  EvtWireIncomingDrawdownRequestReceived = 'wire.incoming_drawdown_request.received',
  EvtWireIncomingDrawdownRequestApproved = 'wire.incoming_drawdown_request.approved',
  EvtWireIncomingDrawdownRequestDenied = 'wire.incoming_drawdown_request.denied',
  EvtWireOutgoingDrawdownRequestInitiated = 'wire.outgoing_drawdown_request.initiated',
  EvtWireOutgoingDrawdownRequestSent = 'wire.outgoing_drawdown_request.sent',
  EvtWireOutgoingDrawdownRequestApproved = 'wire.outgoing_drawdown_request.approved',
  EvtWireOutgoingDrawdownRequestRejected = 'wire.outgoing_drawdown_request.rejected',
  EvtWireIncomingReturnRequestManualReview = 'wire.incoming_return_request.manual_review',
  EvtWireIncomingReturnRequestApproved = 'wire.incoming_return_request.approved',
  EvtWireIncomingReturnRequestRejected = 'wire.incoming_return_request.rejected',
  EvtWireIncomingReturnRequestCompleted = 'wire.incoming_return_request.completed',
  EvtWireOutgoingReturnRequestScheduled = 'wire.outgoing_return_request.scheduled',
  EvtWireOutgoingReturnRequestSent = 'wire.outgoing_return_request.sent',
  EvtWireOutgoingReturnRequestApproved = 'wire.outgoing_return_request.approved',
  EvtWireOutgoingReturnRequestRejected = 'wire.outgoing_return_request.rejected',
  EvtWireOutgoingReturnRequestCompleted = 'wire.outgoing_return_request.completed',
  EvtWireIncomingTransferHoldCreated = 'wire.incoming_transfer.hold_created',
  EvtWireIncomingTransferHoldCleared = 'wire.incoming_transfer.hold_cleared',
  EvtBookTransferCompleted = 'book.transfer.completed',
  EvtBookTransferInitiated = 'book.transfer.initiated',
  EvtBookTransferHoldCreated = 'book.transfer.hold_created',
  EvtBookTransferUpdated = 'book.transfer.updated',
  EvtBookTransferCanceled = 'book.transfer.canceled',
  EvtIdentityVerificationPending = 'identity.verification.pending',
  EvtIdentityVerificationManualReview = 'identity.verification.manual_review',
  EvtIdentityVerificationVerified = 'identity.verification.verified',
  EvtIdentityVerificationDenied = 'identity.verification.denied',
  EvtIdentityCreated = 'identity.created',
  EvtAccountOverdrafted = 'account.overdrafted',
  EvtAccountCreated = 'account.created',
  EvtAccountOverdraftReleased = 'account.overdraft_released',
  DeprecatedEvtAccountUnverified = 'account.unverified',
  EvtAccountFrozen = 'account.frozen',
  EvtAccountUnfrozen = 'account.unfrozen',
  EvtAccountClosed = 'account.closed',
  EvtAccountOpen = 'account.open',
  EvtLoanCreated = 'loan.created',
  EvtLoanUpdated = 'loan.updated',
  EvtLoanInDispute = 'loan.in_dispute',
  EvtLoanDelinquent = 'loan.delinquent',
  EvtLoanPaidOff = 'loan.paid_off',
  EvtLoanChargedOff = 'loan.charged_off',
  EvtLoanCanceled = 'loan.canceled',
  EvtLoanDisbursementHoldCreated = 'loan.disbursement.hold_created',
  EvtLoanDisbursementHoldUpdated = 'loan.disbursement.hold_updated',
  EvtLoanDisbursementHoldCanceled = 'loan.disbursement.hold_canceled',
  EvtLoanDisbursementCompleted = 'loan.disbursement.completed',
  EvtLoanDisbursementManualReview = 'loan.disbursement.manual_review',
  EvtLoanDisbursementRejected = 'loan.disbursement.rejected',
  EvtLoanPaymentCompleted = 'loan.payment.completed',
  EvtLoanSaleCompleted = 'loan.sale.completed',
  EvtLoanPaymentReturned = 'loan.payment.returned',
  EvtBankAccountSummaryScheduled = 'reporting.bank_account_summary.scheduled',
  EvtBankAccountSummaryCompleted = 'reporting.bank_account_summary.completed',
  EvtBankAccountSummaryFailed = 'reporting.bank_account_summary.failed',
  EvtBankAccountTransactionScheduled = 'reporting.bank_account_transaction.scheduled',
  EvtBankAccountTransactionCompleted = 'reporting.bank_account_transaction.completed',
  EvtBankAccountTransactionFailed = 'reporting.bank_account_transaction.failed',
  EvtBankAccountMonthlyStatementCompleted = 'reporting.bank_account_monthly_statement.completed',
  EvtBankAccountDailyStatementCompleted = 'reporting.bank_account_daily_statement.completed',
  EvtBankAccountInterestCompleted = 'reporting.bank_account_interest.completed',
  EvtLoanDailySummaryCompleted = 'reporting.loan_daily_summary.completed',
  EvtSwiftOutgoingTransferInitiated = 'swift.outgoing_transfer.initiated',
  EvtSwiftOutgoingTransferSubmitted = 'swift.outgoing_transfer.submitted',
  EvtSwiftOutgoingTransferPendingReturn = 'swift.outgoing_transfer.pending_return',
  EvtSwiftOutgoingTransferReturned = 'swift.outgoing_transfer.returned',
  EvtSwiftOutgoingTransferCompleted = 'swift.outgoing_transfer.completed',
  EvtSwiftOutgoingTransferManualReview = 'swift.outgoing_transfer.manual_review',
  EvtSwiftOutgoingTransferCancellationRequested = 'swift.outgoing_transfer.cancellation_requested',
  EvtSwiftOutgoingTransferCancellationAccepted = 'swift.outgoing_transfer.cancellation_accepted',
  EvtSwiftOutgoingTransferCancellationRejected = 'swift.outgoing_transfer.cancellation_rejected',
  EvtSwiftOutgoingTransferTrackingUpdated = 'swift.outgoing_transfer.tracking_updated',
  EvtSwiftOutgoingTransferBlocked = 'swift.outgoing_transfer.blocked',
  EvtSwiftIncomingTransferInitiated = 'swift.incoming_transfer.initiated',
  EvtSwiftIncomingTransferCompleted = 'swift.incoming_transfer.completed',
  EvtSwiftIncomingTransferPendingReturn = 'swift.incoming_transfer.pending_return',
  EvtSwiftIncomingTransferReturned = 'swift.incoming_transfer.returned',
  EvtSwiftIncomingTransferCancellationRequested = 'swift.incoming_transfer.cancellation_requested',
  EvtSwiftIncomingTransferCancellationAccepted = 'swift.incoming_transfer.cancellation_accepted',
  EvtSwiftIncomingTransferCancellationRejected = 'swift.incoming_transfer.cancellation_rejected',
  EvtSwiftIncomingTransferTrackingUpdated = 'swift.incoming_transfer.tracking_updated',
  EvtSwiftIncomingTransferPendingReview = 'swift.incoming_transfer.pending_review',
  EvtSwiftOutgoingTransferAmendmentSent = 'swift.outgoing_transfer.amendment_sent',
  EvtSwiftOutgoingTransferAmendmentRequestReceived = 'swift.outgoing_transfer.amendment_request_received',
  EvtSwiftOutgoingTransferPreReview = 'swift.outgoing_transfer.pre_review',
  EvtCheckIncomingDebitSettled = 'check.incoming_debit.settled',
  EvtCheckIncomingDebitPendingStop = 'check.incoming_debit.pending_stop',
  EvtCheckIncomingDebitStopped = 'check.incoming_debit.stopped',
  EvtCheckIncomingDebitReturned = 'check.incoming_debit.returned',
  EvtCheckIncomingDebitInitiated = 'check.incoming_debit.initiated',
  EvtCheckIncomingDebitAutoReturn = 'check.incoming_debit.auto_return',
  EvtCheckIncomingDebitPendingFirstReturn = 'check.incoming_debit.pending_first_return',
  EvtCheckIncomingDebitFirstReturn = 'check.incoming_debit.first_return',
  EvtCheckIncomingDebitUserInitiatedReturnSubmitted = 'check.incoming_debit.user_initiated_return_submitted',
  EvtCheckIncomingDebitUserInitiatedReturned = 'check.incoming_debit.user_initiated_returned',
  EvtCheckIncomingDebitUserInitiatedReturnDishonored = 'check.incoming_debit.user_initiated_return_dishonored',
  EvtCheckIncomingDebitIssued = 'check.incoming_debit.issued',
  EvtCheckIncomingDebitManualReview = 'check.incoming_debit.manual_review',
  EvtCheckIncomingDebitPendingDeposit = 'check.incoming_debit.pending_deposit',
  EvtCheckIncomingDebitRejected = 'check.incoming_debit.rejected',
  EvtCheckIncomingDebitPendingReclear = 'check.incoming_debit.pending_reclear',
  EvtCheckIncomingDebitPendingSecondReturn = 'check.incoming_debit.pending_second_return',
  EvtCheckIncomingDebitSecondReturn = 'check.incoming_debit.second_return',
  EvtCheckIncomingDebitDeliveryCreated = 'check.incoming_debit.delivery.created',
  EvtCheckIncomingDebitDeliveryMailed = 'check.incoming_debit.delivery.mailed',
  EvtCheckIncomingDebitDeliveryInTransit = 'check.incoming_debit.delivery.in_transit',
  EvtCheckIncomingDebitDeliveryInLocalArea = 'check.incoming_debit.delivery.in_local_area',
  EvtCheckIncomingDebitDeliveryProcessedForDelivery = 'check.incoming_debit.delivery.processed_for_delivery',
  EvtCheckIncomingDebitDeliveryDelivered = 'check.incoming_debit.delivery.delivered',
  EvtCheckIncomingDebitDeliveryFailed = 'check.incoming_debit.delivery.failed',
  EvtCheckIncomingDebitDeliveryRerouted = 'check.incoming_debit.delivery.rerouted',
  EvtCheckIncomingDebitDeliveryReturnedToSender = 'check.incoming_debit.delivery.returned_to_sender',
  EvtCheckIncomingDebitDeliveryRenderedPDF = 'check.incoming_debit.delivery.rendered_pdf',
  EvtCheckIncomingDebitPreReview = 'check.incoming_debit.pre_review',
  EvtCheckOutgoingDebitInitiated = 'check.outgoing_debit.initiated',
  EvtCheckOutgoingDebitPendingDeposit = 'check.outgoing_debit.pending_deposit',
  EvtCheckOutgoingDebitManualReview = 'check.outgoing_debit.manual_review',
  EvtCheckOutgoingDebitRejected = 'check.outgoing_debit.rejected',
  EvtCheckOutgoingDebitDeposited = 'check.outgoing_debit.deposited',
  EvtCheckOutgoingDebitPendingReclear = 'check.outgoing_debit.pending_reclear',
  EvtCheckOutgoingDebitRecleared = 'check.outgoing_debit.recleared',
  EvtCheckOutgoingDebitSettled = 'check.outgoing_debit.settled',
  EvtCheckOutgoingDebitReturned = 'check.outgoing_debit.returned',
  EvtCheckLockboxCreated = 'check.lockbox.created',
  EvtCheckLockboxClosed = 'check.lockbox.closed',
  EvtRealtimeOutgoingTransferPreReview = 'realtime.outgoing_transfer.pre_review',
  EvtRealtimeOutgoingTransferInitiated = 'realtime.outgoing_transfer.initiated',
  EvtRealtimeOutgoingTransferBlocked = 'realtime.outgoing_transfer.blocked',
  EvtRealtimeOutgoingTransferRejected = 'realtime.outgoing_transfer.rejected',
  EvtRealtimeOutgoingTransferPending = 'realtime.outgoing_transfer.pending',
  EvtRealtimeOutgoingTransferAccepted = 'realtime.outgoing_transfer.accepted',
  EvtRealtimeOutgoingTransferCompleted = 'realtime.outgoing_transfer.completed',
  EvtRealtimeOutgoingTransferManualReview = 'realtime.outgoing_transfer.manual_review',
  EvtRealtimeOutgoingTransferManualReviewApproved = 'realtime.outgoing_transfer.manual_review_approved',
  EvtRealtimeOutgoingTransferManualReviewRejected = 'realtime.outgoing_transfer.manual_review_rejected',
  EvtRealtimeIncomingTransferAccepted = 'realtime.incoming_transfer.accepted',
  EvtRealtimeIncomingTransferRejected = 'realtime.incoming_transfer.rejected',
  EvtRealtimeIncomingTransferCompleted = 'realtime.incoming_transfer.completed',
  EvtRealtimeOutgoingRFPInitiated = 'realtime.outgoing_request_for_payment.initiated',
  EvtRealtimeOutgoingRFPReceived = 'realtime.outgoing_request_for_payment.received',
  EvtRealtimeOutgoingRFPAccepted = 'realtime.outgoing_request_for_payment.accepted',
  EvtRealtimeOutgoingRFPPresented = 'realtime.outgoing_request_for_payment.presented',
  EvtRealtimeOutgoingRFPCompleted = 'realtime.outgoing_request_for_payment.completed',
  EvtRealtimeOutgoingRFPRejected = 'realtime.outgoing_request_for_payment.rejected',
  EvtRealtimeOutgoingRFPExpired = 'realtime.outgoing_request_for_payment.expired',
  EvtRealtimeOutgoingRFPCanceled = 'realtime.outgoing_request_for_payment.canceled',
  EvtRealtimeIncomingRFPReceived = 'realtime.incoming_request_for_payment.received',
  EvtRealtimeIncomingRFPAccepted = 'realtime.incoming_request_for_payment.accepted',
  EvtRealtimeIncomingRFPPresented = 'realtime.incoming_request_for_payment.presented',
  EvtRealtimeIncomingRFPCompleted = 'realtime.incoming_request_for_payment.completed',
  EvtRealtimeIncomingRFPRejected = 'realtime.incoming_request_for_payment.rejected',
  EvtRealtimeIncomingRFPExpired = 'realtime.incoming_request_for_payment.expired',
  EvtRealtimeIncomingRFPCanceled = 'realtime.incoming_request_for_payment.canceled',
  EvtRealtimeOutgoingReturnRequestPending = 'realtime.outgoing_return_request.pending',
  EvtRealtimeOutgoingReturnRequestAccepted = 'realtime.outgoing_return_request.accepted',
  EvtRealtimeOutgoingReturnRequestRejected = 'realtime.outgoing_return_request.rejected',
  EvtRealtimeIncomingReturnRequestPending = 'realtime.incoming_return_request.pending',
  EvtRealtimeIncomingReturnRequestAccepted = 'realtime.incoming_return_request.accepted',
  EvtRealtimeIncomingReturnRequestRejected = 'realtime.incoming_return_request.rejected',
  EvtInterestPayoutCompleted = 'interest.payout.completed',
  EvtAdminTransferCompleted = 'admin.transfer.completed',
  DeprecatedEvtDecisionCardAuth = 'decision.card.auth',
  DeprecatedEvtDecisionCardsTokensProvisioning = 'decision.cards.tokens.provisioning',
  DeprecatedEvtDecisionCardsTokensDeviceBinding = 'decision.cards.tokens.device_binding',
  DeprecatedEvtCardTransactionCreated = 'card.transaction.created',
  DeprecatedEvtCardTransactionUpdated = 'card.transaction.updated',
  DeprecatedEvtCardThreeDSAuthenticationCompleted = 'card.threeds.authentication_completed',
  DeprecatedEvtCardThreeDSOTPGenerated = 'card.threeds.otp_generated',
  DeprecatedEvtCardsTokensCreated = 'cards.tokens.created',
  DeprecatedEvtCardsTokensActivated = 'cards.tokens.activated',
  DeprecatedEvtCardsTokensPaused = 'cards.tokens.paused',
  DeprecatedEvtCardsTokensDeactivated = 'cards.tokens.deactivated',
  DeprecatedEvtCardsTokensSendPasscode = 'cards.tokens.send_passcode',
  DeprecatedEvtCardsTokensPendingActivation = 'cards.tokens.pending_activation',
  DeprecatedEvtCardsTokensStepUp = 'cards.tokens.step_up',
  DeprecatedEvtCardsTokensPendingAuthentication = 'cards.tokens.pending_authentication',
  DeprecatedEvtCardsTokensActivationDenied = 'cards.tokens.activation_denied',
  DeprecatedEvtCardsTokensCardChanged = 'cards.tokens.card_changed',
  DeprecatedEvtCardsTokensDeviceBindingSendPasscode = 'cards.tokens.device_binding.send_passcode',
  DeprecatedEvtCardsTokensDeviceBindingStepUp = 'cards.tokens.device_binding.step_up',
  DeprecatedEvtCardsTokensDeviceBindingPendingAuthentication = 'cards.tokens.device_binding.pending_authentication',
  EvtLocalOutgoingTransferInitiated = 'local.outgoing_transfer.initiated',
  EvtLocalOutgoingTransferSubmitted = 'local.outgoing_transfer.submitted',
  EvtLocalOutgoingTransferPendingReturn = 'local.outgoing_transfer.pending_return',
  EvtLocalOutgoingTransferReturned = 'local.outgoing_transfer.returned',
  EvtLocalOutgoingTransferCompleted = 'local.outgoing_transfer.completed',
  EvtLocalOutgoingTransferManualReview = 'local.outgoing_transfer.manual_review',
  EvtLocalOutgoingTransferCancellationRequested = 'local.outgoing_transfer.cancellation_requested',
  EvtLocalOutgoingTransferBlocked = 'local.outgoing_transfer.blocked',
  EvtLocalIncomingTransferCompleted = 'local.incoming_transfer.completed',
  EvtLocalIncomingTransferPendingReturn = 'local.incoming_transfer.pending_return',
  EvtLocalIncomingTransferReturned = 'local.incoming_transfer.returned',
  EvtLocalIncomingTransferCancellationRequested = 'local.incoming_transfer.cancellation_requested',
  EvtBankAccountDailyCount = 'bank_account.daily_count',
  EvtEntityDailyCount = 'identity.daily_count',
  EvtActiveLoanDailyCount = 'loan.active_daily_count',
  Evt180DayActiveBankAccountCount = 'bank_account.180day_active_daily_count',
  Evt180DayActiveEntityCount = 'identity.180day_active_daily_count',
  EvtExpandedFDICInsuranceDailyBalance = 'bank_account.expanded_fdic_insurance_daily_balance',
  Evt180DayActiveEntityWithAccountStructureCount = 'identity.180day__active_with_account_structure_daily_count',
  EvtEntitiesWithFirstBankAccountCreatedCount = 'identity.entities_with_first_bank_account_created',
  DeprecatedEvtCardCreated = 'cards.card.created',
  DeprecatedEvtCardActivated = 'cards.card.activated',
  DeprecatedEvtCardPaused = 'cards.card.paused',
  DeprecatedEvtCardInactive = 'cards.card.inactive',
  EvtTaxFormFedSent = 'tax_form.fed_sent',
  EvtTaxFormFedAccepted = 'tax_form.fed_accepted',
  EvtTaxFormFedRejected = 'tax_form.fed_rejected',
  EvtTaxFormStateSent = 'tax_form.state_sent',
  EvtTaxFormStateAccepted = 'tax_form.state_accepted',
  EvtTaxFormStateRejected = 'tax_form.state_rejected',
  EvtTaxFormMailSent = 'tax_form.mail_sent',
  EvtTaxFormMailReceived = 'tax_form.mail_received',
  EvtTaxFormScheduled = 'tax_form.scheduled',
  EvtTaxFormCanceled = 'tax_form.canceled',
  EvtTaxFormPDFdReady = 'tax_form.pdf_ready',
  EvtCryptoIncomingTransferInitiated = 'crypto.incoming_transfer.initiated',
  EvtCryptoIncomingTransferCompleted = 'crypto.incoming_transfer.completed',
  EvtCryptoIncomingTransferCounterpartyResolved = 'crypto.incoming_transfer.counterparty_resolved',
  EvtCryptoIncomingTransferReturned = 'crypto.incoming_transfer.returned',
  EvtCryptoIncomingTransferDetected = 'crypto.incoming_transfer.detected',
  EvtCryptoIncomingTransferManualReview = 'crypto.incoming_transfer.manual_review',
  EvtCryptoOutgoingTransferInitiated = 'crypto.outgoing_transfer.initiated',
  EvtCryptoOutgoingTransferSubmitted = 'crypto.outgoing_transfer.submitted',
  EvtCryptoOutgoingTransferCompleted = 'crypto.outgoing_transfer.completed',
  EvtCryptoOutgoingTransferReturned = 'crypto.outgoing_transfer.returned',
  EvtCryptoOutgoingTransferManualReview = 'crypto.outgoing_transfer.manual_review',
  EvtCryptoOutgoingTransferManualReviewApproved = 'crypto.outgoing_transfer.manual_review_approved',
  EvtCryptoIncomingTransferRemoved = 'crypto.incoming_transfer.removed',
  EvtCryptoIncomingTransferPIIReceived = 'crypto.incoming_transfer.pii_received',
  EvtACHTransferBatchValidated = 'ach_transfer_batch.validated',
  EvtACHTransferBatchProcessing = 'ach_transfer_batch.processing',
  EvtACHTransferBatchCompleted = 'ach_transfer_batch.completed',
  EvtACHTransferBatchFailed = 'ach_transfer_batch.failed',
  EvtACHTransferBatchExpired = 'ach_transfer_batch.expired',
  EvtCheckIssuanceBatchValidated = 'check_issuance_batch.validated',
  EvtCheckIssuanceBatchProcessing = 'check_issuance_batch.processing',
  EvtCheckIssuanceBatchCompleted = 'check_issuance_batch.completed',
  EvtCheckIssuanceBatchFailed = 'check_issuance_batch.failed',
  EvtCheckIssuanceBatchExpired = 'check_issuance_batch.expired',
  EvtIssuingCardTransactionCreated = 'issuing.card_transaction.created',
  EvtIssuingCardTransactionUpdated = 'issuing.card_transaction.updated',
  EvtIssuingCardTransactionTransactionDataUpdated = 'issuing.card_transaction.transaction_data_updated',
  EvtIssuingCardDisputeCreated = 'issuing.card_dispute.created',
  EvtIssuingCardDisputeUpdated = 'issuing.card_dispute.updated',
  EvtIssuing3DSAuthenticationCompleted = 'issuing.3ds.authentication_completed',
  EvtIssuing3DSOTPGenerated = 'issuing.3ds.otp_generated',
  EvtIssuingCardCreated = 'issuing.card.created',
  EvtIssuingCardActivated = 'issuing.card.activated',
  EvtIssuingCardPaused = 'issuing.card.paused',
  EvtIssuingCardInactive = 'issuing.card.inactive',
  EvtIssuingCardTokenCreated = 'issuing.card_token.created',
  EvtIssuingCardTokenActivated = 'issuing.card_token.activated',
  EvtIssuingCardTokenPaused = 'issuing.card_token.paused',
  EvtIssuingCardTokenDeactivated = 'issuing.card_token.deactivated',
  EvtIssuingCardTokenPendingActivation = 'issuing.card_token.pending_activation',
  EvtIssuingCardTokenActivationDenied = 'issuing.card_token.activation_denied',
  EvtIssuingCardTokenCardChanged = 'issuing.card_token.card_changed',
  EvtIssuingCardTokenSendPasscode = 'issuing.card_token.send_passcode',
  EvtIssuingCardTokenStepUp = 'issuing.card_token.step_up',
  EvtIssuingCardTokenPendingAuthentication = 'issuing.card_token.pending_authentication',
  EvtIssuingCardTokenDeviceBindingSendPasscode = 'issuing.card_token.device_binding.send_passcode',
  EvtIssuingCardTokenDeviceBindingStepUp = 'issuing.card_token.device_binding.step_up',
  EvtIssuingCardTokenDeviceBindingPendingAuthentication = 'issuing.card_token.device_binding.pending_authentication',
  EvtDecisionIssuingCardTransaction = 'decision.issuing.card_transaction',
  EvtDecisionIssuingCardToken = 'decision.issuing.card_token',
  EvtDecisionIssuingCardTokenDeviceBinding = 'decision.issuing.card_token.device_binding',
  EvtIssuingCardAccountCreated = 'issuing.card_account.created',
  EvtIssuingCardRevealTokenCreated = 'issuing.card_reveal_token.created',
  EvtIssuingCardRevealTokenConsumed = 'issuing.card_reveal_token.consumed',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export const EventTypeFromJSON = (object: any) => {
  switch (object) {
    case 26:
    case 'ach.outgoing_transfer.pre_review':
      return EventType.EvtACHOutgoingTransferPreReview;
    case 1:
    case 'ach.outgoing_transfer.initiated':
      return EventType.EvtACHOutgoingTransferInitiated;
    case 2:
    case 'ach.outgoing_transfer.submitted':
      return EventType.EvtACHOutgoingTransferSubmitted;
    case 4:
    case 'ach.outgoing_transfer.settled':
      return EventType.EvtACHOutgoingTransferSettled;
    case 5:
    case 'ach.outgoing_transfer.completed':
      return EventType.EvtACHOutgoingTransferCompleted;
    case 19:
    case 'ach.outgoing_transfer.manual_review':
      return EventType.EvtACHOutgoingTransferManualReview;
    case 6:
    case 'ach.outgoing_transfer.returned':
      return EventType.EvtACHOutgoingTransferReturned;
    case 7:
    case 'ach.outgoing_transfer.canceled':
      return EventType.EvtACHOutgoingTransferCanceled;
    case 20:
    case 'ach.outgoing_transfer.return_dishonored':
      return EventType.EvtACHOutgoingTransferReturnDishonored;
    case 25:
    case 'ach.outgoing_transfer.return_dishonored_funds_unlocked':
      return EventType.EvtACHOutgoingTransferReturnDishonoredFundsUnlocked;
    case 21:
    case 'ach.outgoing_transfer.return_contested':
      return EventType.EvtACHOutgoingTransferReturnContested;
    case 24:
    case 'ach.outgoing_transfer.noc':
      return EventType.EvtACHOutgoingTransferNOC;
    case 8:
    case 'ach.incoming_transfer.settled':
      return EventType.EvtACHIncomingTransferSettled;
    case 9:
    case 'ach.incoming_transfer.completed':
      return EventType.EvtACHIncomingTransferCompleted;
    case 10:
    case 'ach.incoming_transfer.nsf':
      return EventType.EvtACHIncomingTransferNSF;
    case 11:
    case 'ach.incoming_transfer.returned':
      return EventType.EvtACHIncomingTransferReturned;
    case 12:
    case 'ach.incoming_transfer.scheduled':
      return EventType.EvtACHIncomingTransferScheduled;
    case 22:
    case 'ach.incoming_transfer.return_dishonored':
      return EventType.EvtACHIncomingTransferReturnDishonored;
    case 23:
    case 'ach.incoming_transfer.return_contested':
      return EventType.EvtACHIncomingTransferReturnContested;
    case 359:
    case 'wire.outgoing_transfer.pre_review':
      return EventType.EvtWireOutgoingTransferPreReview;
    case 31:
    case 'wire.outgoing_transfer.initiated':
      return EventType.EvtWireOutgoingTransferInitiated;
    case 32:
    case 'wire.outgoing_transfer.submitted':
      return EventType.EvtWireOutgoingTransferSubmitted;
    case 33:
    case 'wire.outgoing_transfer.rejected':
      return EventType.EvtWireOutgoingTransferRejected;
    case 34:
    case 'wire.outgoing_transfer.completed':
      return EventType.EvtWireOutgoingTransferCompleted;
    case 35:
    case 'wire.incoming_transfer.completed':
      return EventType.EvtWireIncomingTransferCompleted;
    case 36:
    case 'wire.incoming_transfer.rejected':
      return EventType.EvtWireIncomingTransferRejected;
    case 37:
    case 'wire.outgoing_transfer.manual_review':
      return EventType.EvtWireOutgoingTransferManualReview;
    case 38:
    case 'wire.incoming_drawdown_request.received':
      return EventType.EvtWireIncomingDrawdownRequestReceived;
    case 39:
    case 'wire.incoming_drawdown_request.approved':
      return EventType.EvtWireIncomingDrawdownRequestApproved;
    case 40:
    case 'wire.incoming_drawdown_request.denied':
      return EventType.EvtWireIncomingDrawdownRequestDenied;
    case 41:
    case 'wire.outgoing_drawdown_request.initiated':
      return EventType.EvtWireOutgoingDrawdownRequestInitiated;
    case 42:
    case 'wire.outgoing_drawdown_request.sent':
      return EventType.EvtWireOutgoingDrawdownRequestSent;
    case 43:
    case 'wire.outgoing_drawdown_request.approved':
      return EventType.EvtWireOutgoingDrawdownRequestApproved;
    case 44:
    case 'wire.outgoing_drawdown_request.rejected':
      return EventType.EvtWireOutgoingDrawdownRequestRejected;
    case 45:
    case 'wire.incoming_return_request.manual_review':
      return EventType.EvtWireIncomingReturnRequestManualReview;
    case 46:
    case 'wire.incoming_return_request.approved':
      return EventType.EvtWireIncomingReturnRequestApproved;
    case 47:
    case 'wire.incoming_return_request.rejected':
      return EventType.EvtWireIncomingReturnRequestRejected;
    case 48:
    case 'wire.incoming_return_request.completed':
      return EventType.EvtWireIncomingReturnRequestCompleted;
    case 49:
    case 'wire.outgoing_return_request.scheduled':
      return EventType.EvtWireOutgoingReturnRequestScheduled;
    case 50:
    case 'wire.outgoing_return_request.sent':
      return EventType.EvtWireOutgoingReturnRequestSent;
    case 356:
    case 'wire.outgoing_return_request.approved':
      return EventType.EvtWireOutgoingReturnRequestApproved;
    case 357:
    case 'wire.outgoing_return_request.rejected':
      return EventType.EvtWireOutgoingReturnRequestRejected;
    case 358:
    case 'wire.outgoing_return_request.completed':
      return EventType.EvtWireOutgoingReturnRequestCompleted;
    case 360:
    case 'wire.incoming_transfer.hold_created':
      return EventType.EvtWireIncomingTransferHoldCreated;
    case 361:
    case 'wire.incoming_transfer.hold_cleared':
      return EventType.EvtWireIncomingTransferHoldCleared;
    case 51:
    case 'book.transfer.completed':
      return EventType.EvtBookTransferCompleted;
    case 52:
    case 'book.transfer.initiated':
      return EventType.EvtBookTransferInitiated;
    case 53:
    case 'book.transfer.hold_created':
      return EventType.EvtBookTransferHoldCreated;
    case 54:
    case 'book.transfer.updated':
      return EventType.EvtBookTransferUpdated;
    case 55:
    case 'book.transfer.canceled':
      return EventType.EvtBookTransferCanceled;
    case 61:
    case 'identity.verification.pending':
      return EventType.EvtIdentityVerificationPending;
    case 62:
    case 'identity.verification.manual_review':
      return EventType.EvtIdentityVerificationManualReview;
    case 63:
    case 'identity.verification.verified':
      return EventType.EvtIdentityVerificationVerified;
    case 64:
    case 'identity.verification.denied':
      return EventType.EvtIdentityVerificationDenied;
    case 65:
    case 'identity.created':
      return EventType.EvtIdentityCreated;
    case 81:
    case 'account.overdrafted':
      return EventType.EvtAccountOverdrafted;
    case 82:
    case 'account.created':
      return EventType.EvtAccountCreated;
    case 83:
    case 'account.overdraft_released':
      return EventType.EvtAccountOverdraftReleased;
    case 84:
    case 'account.unverified':
      return EventType.DeprecatedEvtAccountUnverified;
    case 85:
    case 'account.frozen':
      return EventType.EvtAccountFrozen;
    case 86:
    case 'account.unfrozen':
      return EventType.EvtAccountUnfrozen;
    case 87:
    case 'account.closed':
      return EventType.EvtAccountClosed;
    case 88:
    case 'account.open':
      return EventType.EvtAccountOpen;
    case 121:
    case 'loan.created':
      return EventType.EvtLoanCreated;
    case 122:
    case 'loan.updated':
      return EventType.EvtLoanUpdated;
    case 123:
    case 'loan.in_dispute':
      return EventType.EvtLoanInDispute;
    case 124:
    case 'loan.delinquent':
      return EventType.EvtLoanDelinquent;
    case 125:
    case 'loan.paid_off':
      return EventType.EvtLoanPaidOff;
    case 126:
    case 'loan.charged_off':
      return EventType.EvtLoanChargedOff;
    case 127:
    case 'loan.canceled':
      return EventType.EvtLoanCanceled;
    case 141:
    case 'loan.disbursement.hold_created':
      return EventType.EvtLoanDisbursementHoldCreated;
    case 142:
    case 'loan.disbursement.hold_updated':
      return EventType.EvtLoanDisbursementHoldUpdated;
    case 143:
    case 'loan.disbursement.hold_canceled':
      return EventType.EvtLoanDisbursementHoldCanceled;
    case 144:
    case 'loan.disbursement.completed':
      return EventType.EvtLoanDisbursementCompleted;
    case 145:
    case 'loan.disbursement.manual_review':
      return EventType.EvtLoanDisbursementManualReview;
    case 146:
    case 'loan.disbursement.rejected':
      return EventType.EvtLoanDisbursementRejected;
    case 151:
    case 'loan.payment.completed':
      return EventType.EvtLoanPaymentCompleted;
    case 152:
    case 'loan.sale.completed':
      return EventType.EvtLoanSaleCompleted;
    case 153:
    case 'loan.payment.returned':
      return EventType.EvtLoanPaymentReturned;
    case 161:
    case 'reporting.bank_account_summary.scheduled':
      return EventType.EvtBankAccountSummaryScheduled;
    case 162:
    case 'reporting.bank_account_summary.completed':
      return EventType.EvtBankAccountSummaryCompleted;
    case 163:
    case 'reporting.bank_account_summary.failed':
      return EventType.EvtBankAccountSummaryFailed;
    case 164:
    case 'reporting.bank_account_transaction.scheduled':
      return EventType.EvtBankAccountTransactionScheduled;
    case 165:
    case 'reporting.bank_account_transaction.completed':
      return EventType.EvtBankAccountTransactionCompleted;
    case 166:
    case 'reporting.bank_account_transaction.failed':
      return EventType.EvtBankAccountTransactionFailed;
    case 168:
    case 'reporting.bank_account_monthly_statement.completed':
      return EventType.EvtBankAccountMonthlyStatementCompleted;
    case 171:
    case 'reporting.bank_account_daily_statement.completed':
      return EventType.EvtBankAccountDailyStatementCompleted;
    case 173:
    case 'reporting.bank_account_interest.completed':
      return EventType.EvtBankAccountInterestCompleted;
    case 174:
    case 'reporting.loan_daily_summary.completed':
      return EventType.EvtLoanDailySummaryCompleted;
    case 221:
    case 'swift.outgoing_transfer.initiated':
      return EventType.EvtSwiftOutgoingTransferInitiated;
    case 222:
    case 'swift.outgoing_transfer.submitted':
      return EventType.EvtSwiftOutgoingTransferSubmitted;
    case 238:
    case 'swift.outgoing_transfer.pending_return':
      return EventType.EvtSwiftOutgoingTransferPendingReturn;
    case 223:
    case 'swift.outgoing_transfer.returned':
      return EventType.EvtSwiftOutgoingTransferReturned;
    case 224:
    case 'swift.outgoing_transfer.completed':
      return EventType.EvtSwiftOutgoingTransferCompleted;
    case 225:
    case 'swift.outgoing_transfer.manual_review':
      return EventType.EvtSwiftOutgoingTransferManualReview;
    case 233:
    case 'swift.outgoing_transfer.cancellation_requested':
      return EventType.EvtSwiftOutgoingTransferCancellationRequested;
    case 234:
    case 'swift.outgoing_transfer.cancellation_accepted':
      return EventType.EvtSwiftOutgoingTransferCancellationAccepted;
    case 235:
    case 'swift.outgoing_transfer.cancellation_rejected':
      return EventType.EvtSwiftOutgoingTransferCancellationRejected;
    case 236:
    case 'swift.outgoing_transfer.tracking_updated':
      return EventType.EvtSwiftOutgoingTransferTrackingUpdated;
    case 239:
    case 'swift.outgoing_transfer.blocked':
      return EventType.EvtSwiftOutgoingTransferBlocked;
    case 229:
    case 'swift.incoming_transfer.initiated':
      return EventType.EvtSwiftIncomingTransferInitiated;
    case 226:
    case 'swift.incoming_transfer.completed':
      return EventType.EvtSwiftIncomingTransferCompleted;
    case 230:
    case 'swift.incoming_transfer.pending_return':
      return EventType.EvtSwiftIncomingTransferPendingReturn;
    case 227:
    case 'swift.incoming_transfer.returned':
      return EventType.EvtSwiftIncomingTransferReturned;
    case 228:
    case 'swift.incoming_transfer.cancellation_requested':
      return EventType.EvtSwiftIncomingTransferCancellationRequested;
    case 231:
    case 'swift.incoming_transfer.cancellation_accepted':
      return EventType.EvtSwiftIncomingTransferCancellationAccepted;
    case 232:
    case 'swift.incoming_transfer.cancellation_rejected':
      return EventType.EvtSwiftIncomingTransferCancellationRejected;
    case 237:
    case 'swift.incoming_transfer.tracking_updated':
      return EventType.EvtSwiftIncomingTransferTrackingUpdated;
    case 240:
    case 'swift.incoming_transfer.pending_review':
      return EventType.EvtSwiftIncomingTransferPendingReview;
    case 391:
    case 'swift.outgoing_transfer.amendment_sent':
      return EventType.EvtSwiftOutgoingTransferAmendmentSent;
    case 392:
    case 'swift.outgoing_transfer.amendment_request_received':
      return EventType.EvtSwiftOutgoingTransferAmendmentRequestReceived;
    case 393:
    case 'swift.outgoing_transfer.pre_review':
      return EventType.EvtSwiftOutgoingTransferPreReview;
    case 241:
    case 'check.incoming_debit.settled':
      return EventType.EvtCheckIncomingDebitSettled;
    case 270:
    case 'check.incoming_debit.pending_stop':
      return EventType.EvtCheckIncomingDebitPendingStop;
    case 242:
    case 'check.incoming_debit.stopped':
      return EventType.EvtCheckIncomingDebitStopped;
    case 247:
    case 'check.incoming_debit.returned':
      return EventType.EvtCheckIncomingDebitReturned;
    case 277:
    case 'check.incoming_debit.initiated':
      return EventType.EvtCheckIncomingDebitInitiated;
    case 248:
    case 'check.incoming_debit.auto_return':
      return EventType.EvtCheckIncomingDebitAutoReturn;
    case 249:
    case 'check.incoming_debit.pending_first_return':
      return EventType.EvtCheckIncomingDebitPendingFirstReturn;
    case 274:
    case 'check.incoming_debit.first_return':
      return EventType.EvtCheckIncomingDebitFirstReturn;
    case 275:
    case 'check.incoming_debit.user_initiated_return_submitted':
      return EventType.EvtCheckIncomingDebitUserInitiatedReturnSubmitted;
    case 250:
    case 'check.incoming_debit.user_initiated_returned':
      return EventType.EvtCheckIncomingDebitUserInitiatedReturned;
    case 276:
    case 'check.incoming_debit.user_initiated_return_dishonored':
      return EventType.EvtCheckIncomingDebitUserInitiatedReturnDishonored;
    case 251:
    case 'check.incoming_debit.issued':
      return EventType.EvtCheckIncomingDebitIssued;
    case 252:
    case 'check.incoming_debit.manual_review':
      return EventType.EvtCheckIncomingDebitManualReview;
    case 259:
    case 'check.incoming_debit.pending_deposit':
      return EventType.EvtCheckIncomingDebitPendingDeposit;
    case 253:
    case 'check.incoming_debit.rejected':
      return EventType.EvtCheckIncomingDebitRejected;
    case 254:
    case 'check.incoming_debit.pending_reclear':
      return EventType.EvtCheckIncomingDebitPendingReclear;
    case 255:
    case 'check.incoming_debit.pending_second_return':
      return EventType.EvtCheckIncomingDebitPendingSecondReturn;
    case 256:
    case 'check.incoming_debit.second_return':
      return EventType.EvtCheckIncomingDebitSecondReturn;
    case 260:
    case 'check.incoming_debit.delivery.created':
      return EventType.EvtCheckIncomingDebitDeliveryCreated;
    case 261:
    case 'check.incoming_debit.delivery.mailed':
      return EventType.EvtCheckIncomingDebitDeliveryMailed;
    case 262:
    case 'check.incoming_debit.delivery.in_transit':
      return EventType.EvtCheckIncomingDebitDeliveryInTransit;
    case 263:
    case 'check.incoming_debit.delivery.in_local_area':
      return EventType.EvtCheckIncomingDebitDeliveryInLocalArea;
    case 264:
    case 'check.incoming_debit.delivery.processed_for_delivery':
      return EventType.EvtCheckIncomingDebitDeliveryProcessedForDelivery;
    case 265:
    case 'check.incoming_debit.delivery.delivered':
      return EventType.EvtCheckIncomingDebitDeliveryDelivered;
    case 266:
    case 'check.incoming_debit.delivery.failed':
      return EventType.EvtCheckIncomingDebitDeliveryFailed;
    case 267:
    case 'check.incoming_debit.delivery.rerouted':
      return EventType.EvtCheckIncomingDebitDeliveryRerouted;
    case 268:
    case 'check.incoming_debit.delivery.returned_to_sender':
      return EventType.EvtCheckIncomingDebitDeliveryReturnedToSender;
    case 278:
    case 'check.incoming_debit.delivery.rendered_pdf':
      return EventType.EvtCheckIncomingDebitDeliveryRenderedPDF;
    case 281:
    case 'check.incoming_debit.pre_review':
      return EventType.EvtCheckIncomingDebitPreReview;
    case 243:
    case 'check.outgoing_debit.initiated':
      return EventType.EvtCheckOutgoingDebitInitiated;
    case 273:
    case 'check.outgoing_debit.pending_deposit':
      return EventType.EvtCheckOutgoingDebitPendingDeposit;
    case 271:
    case 'check.outgoing_debit.manual_review':
      return EventType.EvtCheckOutgoingDebitManualReview;
    case 272:
    case 'check.outgoing_debit.rejected':
      return EventType.EvtCheckOutgoingDebitRejected;
    case 244:
    case 'check.outgoing_debit.deposited':
      return EventType.EvtCheckOutgoingDebitDeposited;
    case 257:
    case 'check.outgoing_debit.pending_reclear':
      return EventType.EvtCheckOutgoingDebitPendingReclear;
    case 258:
    case 'check.outgoing_debit.recleared':
      return EventType.EvtCheckOutgoingDebitRecleared;
    case 245:
    case 'check.outgoing_debit.settled':
      return EventType.EvtCheckOutgoingDebitSettled;
    case 246:
    case 'check.outgoing_debit.returned':
      return EventType.EvtCheckOutgoingDebitReturned;
    case 279:
    case 'check.lockbox.created':
      return EventType.EvtCheckLockboxCreated;
    case 280:
    case 'check.lockbox.closed':
      return EventType.EvtCheckLockboxClosed;
    case 324:
    case 'realtime.outgoing_transfer.pre_review':
      return EventType.EvtRealtimeOutgoingTransferPreReview;
    case 291:
    case 'realtime.outgoing_transfer.initiated':
      return EventType.EvtRealtimeOutgoingTransferInitiated;
    case 292:
    case 'realtime.outgoing_transfer.blocked':
      return EventType.EvtRealtimeOutgoingTransferBlocked;
    case 293:
    case 'realtime.outgoing_transfer.rejected':
      return EventType.EvtRealtimeOutgoingTransferRejected;
    case 294:
    case 'realtime.outgoing_transfer.pending':
      return EventType.EvtRealtimeOutgoingTransferPending;
    case 295:
    case 'realtime.outgoing_transfer.accepted':
      return EventType.EvtRealtimeOutgoingTransferAccepted;
    case 296:
    case 'realtime.outgoing_transfer.completed':
      return EventType.EvtRealtimeOutgoingTransferCompleted;
    case 300:
    case 'realtime.outgoing_transfer.manual_review':
      return EventType.EvtRealtimeOutgoingTransferManualReview;
    case 301:
    case 'realtime.outgoing_transfer.manual_review_approved':
      return EventType.EvtRealtimeOutgoingTransferManualReviewApproved;
    case 302:
    case 'realtime.outgoing_transfer.manual_review_rejected':
      return EventType.EvtRealtimeOutgoingTransferManualReviewRejected;
    case 297:
    case 'realtime.incoming_transfer.accepted':
      return EventType.EvtRealtimeIncomingTransferAccepted;
    case 298:
    case 'realtime.incoming_transfer.rejected':
      return EventType.EvtRealtimeIncomingTransferRejected;
    case 299:
    case 'realtime.incoming_transfer.completed':
      return EventType.EvtRealtimeIncomingTransferCompleted;
    case 303:
    case 'realtime.outgoing_request_for_payment.initiated':
      return EventType.EvtRealtimeOutgoingRFPInitiated;
    case 304:
    case 'realtime.outgoing_request_for_payment.received':
      return EventType.EvtRealtimeOutgoingRFPReceived;
    case 305:
    case 'realtime.outgoing_request_for_payment.accepted':
      return EventType.EvtRealtimeOutgoingRFPAccepted;
    case 306:
    case 'realtime.outgoing_request_for_payment.presented':
      return EventType.EvtRealtimeOutgoingRFPPresented;
    case 307:
    case 'realtime.outgoing_request_for_payment.completed':
      return EventType.EvtRealtimeOutgoingRFPCompleted;
    case 308:
    case 'realtime.outgoing_request_for_payment.rejected':
      return EventType.EvtRealtimeOutgoingRFPRejected;
    case 309:
    case 'realtime.outgoing_request_for_payment.expired':
      return EventType.EvtRealtimeOutgoingRFPExpired;
    case 310:
    case 'realtime.outgoing_request_for_payment.canceled':
      return EventType.EvtRealtimeOutgoingRFPCanceled;
    case 311:
    case 'realtime.incoming_request_for_payment.received':
      return EventType.EvtRealtimeIncomingRFPReceived;
    case 312:
    case 'realtime.incoming_request_for_payment.accepted':
      return EventType.EvtRealtimeIncomingRFPAccepted;
    case 313:
    case 'realtime.incoming_request_for_payment.presented':
      return EventType.EvtRealtimeIncomingRFPPresented;
    case 314:
    case 'realtime.incoming_request_for_payment.completed':
      return EventType.EvtRealtimeIncomingRFPCompleted;
    case 315:
    case 'realtime.incoming_request_for_payment.rejected':
      return EventType.EvtRealtimeIncomingRFPRejected;
    case 316:
    case 'realtime.incoming_request_for_payment.expired':
      return EventType.EvtRealtimeIncomingRFPExpired;
    case 317:
    case 'realtime.incoming_request_for_payment.canceled':
      return EventType.EvtRealtimeIncomingRFPCanceled;
    case 318:
    case 'realtime.outgoing_return_request.pending':
      return EventType.EvtRealtimeOutgoingReturnRequestPending;
    case 319:
    case 'realtime.outgoing_return_request.accepted':
      return EventType.EvtRealtimeOutgoingReturnRequestAccepted;
    case 320:
    case 'realtime.outgoing_return_request.rejected':
      return EventType.EvtRealtimeOutgoingReturnRequestRejected;
    case 321:
    case 'realtime.incoming_return_request.pending':
      return EventType.EvtRealtimeIncomingReturnRequestPending;
    case 322:
    case 'realtime.incoming_return_request.accepted':
      return EventType.EvtRealtimeIncomingReturnRequestAccepted;
    case 323:
    case 'realtime.incoming_return_request.rejected':
      return EventType.EvtRealtimeIncomingReturnRequestRejected;
    case 331:
    case 'interest.payout.completed':
      return EventType.EvtInterestPayoutCompleted;
    case 351:
    case 'admin.transfer.completed':
      return EventType.EvtAdminTransferCompleted;
    case 381:
    case 'decision.card.auth':
      return EventType.DeprecatedEvtDecisionCardAuth;
    case 382:
    case 'decision.cards.tokens.provisioning':
      return EventType.DeprecatedEvtDecisionCardsTokensProvisioning;
    case 383:
    case 'decision.cards.tokens.device_binding':
      return EventType.DeprecatedEvtDecisionCardsTokensDeviceBinding;
    case 405:
    case 'card.transaction.created':
      return EventType.DeprecatedEvtCardTransactionCreated;
    case 406:
    case 'card.transaction.updated':
      return EventType.DeprecatedEvtCardTransactionUpdated;
    case 407:
    case 'card.threeds.authentication_completed':
      return EventType.DeprecatedEvtCardThreeDSAuthenticationCompleted;
    case 408:
    case 'card.threeds.otp_generated':
      return EventType.DeprecatedEvtCardThreeDSOTPGenerated;
    case 409:
    case 'cards.tokens.created':
      return EventType.DeprecatedEvtCardsTokensCreated;
    case 410:
    case 'cards.tokens.activated':
      return EventType.DeprecatedEvtCardsTokensActivated;
    case 411:
    case 'cards.tokens.paused':
      return EventType.DeprecatedEvtCardsTokensPaused;
    case 412:
    case 'cards.tokens.deactivated':
      return EventType.DeprecatedEvtCardsTokensDeactivated;
    case 413:
    case 'cards.tokens.send_passcode':
      return EventType.DeprecatedEvtCardsTokensSendPasscode;
    case 414:
    case 'cards.tokens.pending_activation':
      return EventType.DeprecatedEvtCardsTokensPendingActivation;
    case 415:
    case 'cards.tokens.step_up':
      return EventType.DeprecatedEvtCardsTokensStepUp;
    case 416:
    case 'cards.tokens.pending_authentication':
      return EventType.DeprecatedEvtCardsTokensPendingAuthentication;
    case 417:
    case 'cards.tokens.activation_denied':
      return EventType.DeprecatedEvtCardsTokensActivationDenied;
    case 418:
    case 'cards.tokens.card_changed':
      return EventType.DeprecatedEvtCardsTokensCardChanged;
    case 419:
    case 'cards.tokens.device_binding.send_passcode':
      return EventType.DeprecatedEvtCardsTokensDeviceBindingSendPasscode;
    case 420:
    case 'cards.tokens.device_binding.step_up':
      return EventType.DeprecatedEvtCardsTokensDeviceBindingStepUp;
    case 421:
    case 'cards.tokens.device_binding.pending_authentication':
      return EventType.DeprecatedEvtCardsTokensDeviceBindingPendingAuthentication;
    case 425:
    case 'local.outgoing_transfer.initiated':
      return EventType.EvtLocalOutgoingTransferInitiated;
    case 426:
    case 'local.outgoing_transfer.submitted':
      return EventType.EvtLocalOutgoingTransferSubmitted;
    case 427:
    case 'local.outgoing_transfer.pending_return':
      return EventType.EvtLocalOutgoingTransferPendingReturn;
    case 428:
    case 'local.outgoing_transfer.returned':
      return EventType.EvtLocalOutgoingTransferReturned;
    case 429:
    case 'local.outgoing_transfer.completed':
      return EventType.EvtLocalOutgoingTransferCompleted;
    case 430:
    case 'local.outgoing_transfer.manual_review':
      return EventType.EvtLocalOutgoingTransferManualReview;
    case 431:
    case 'local.outgoing_transfer.cancellation_requested':
      return EventType.EvtLocalOutgoingTransferCancellationRequested;
    case 432:
    case 'local.outgoing_transfer.blocked':
      return EventType.EvtLocalOutgoingTransferBlocked;
    case 433:
    case 'local.incoming_transfer.completed':
      return EventType.EvtLocalIncomingTransferCompleted;
    case 434:
    case 'local.incoming_transfer.pending_return':
      return EventType.EvtLocalIncomingTransferPendingReturn;
    case 435:
    case 'local.incoming_transfer.returned':
      return EventType.EvtLocalIncomingTransferReturned;
    case 436:
    case 'local.incoming_transfer.cancellation_requested':
      return EventType.EvtLocalIncomingTransferCancellationRequested;
    case 1000:
    case 'bank_account.daily_count':
      return EventType.EvtBankAccountDailyCount;
    case 1001:
    case 'identity.daily_count':
      return EventType.EvtEntityDailyCount;
    case 1002:
    case 'loan.active_daily_count':
      return EventType.EvtActiveLoanDailyCount;
    case 1003:
    case 'bank_account.180day_active_daily_count':
      return EventType.Evt180DayActiveBankAccountCount;
    case 1004:
    case 'identity.180day_active_daily_count':
      return EventType.Evt180DayActiveEntityCount;
    case 1005:
    case 'bank_account.expanded_fdic_insurance_daily_balance':
      return EventType.EvtExpandedFDICInsuranceDailyBalance;
    case 1006:
    case 'identity.180day__active_with_account_structure_daily_count':
      return EventType.Evt180DayActiveEntityWithAccountStructureCount;
    case 1007:
    case 'identity.entities_with_first_bank_account_created':
      return EventType.EvtEntitiesWithFirstBankAccountCreatedCount;
    case 2001:
    case 'cards.card.created':
      return EventType.DeprecatedEvtCardCreated;
    case 2002:
    case 'cards.card.activated':
      return EventType.DeprecatedEvtCardActivated;
    case 2003:
    case 'cards.card.paused':
      return EventType.DeprecatedEvtCardPaused;
    case 2004:
    case 'cards.card.inactive':
      return EventType.DeprecatedEvtCardInactive;
    case 2021:
    case 'tax_form.fed_sent':
      return EventType.EvtTaxFormFedSent;
    case 2022:
    case 'tax_form.fed_accepted':
      return EventType.EvtTaxFormFedAccepted;
    case 2023:
    case 'tax_form.fed_rejected':
      return EventType.EvtTaxFormFedRejected;
    case 2024:
    case 'tax_form.state_sent':
      return EventType.EvtTaxFormStateSent;
    case 2025:
    case 'tax_form.state_accepted':
      return EventType.EvtTaxFormStateAccepted;
    case 2026:
    case 'tax_form.state_rejected':
      return EventType.EvtTaxFormStateRejected;
    case 2027:
    case 'tax_form.mail_sent':
      return EventType.EvtTaxFormMailSent;
    case 2028:
    case 'tax_form.mail_received':
      return EventType.EvtTaxFormMailReceived;
    case 2029:
    case 'tax_form.scheduled':
      return EventType.EvtTaxFormScheduled;
    case 2030:
    case 'tax_form.canceled':
      return EventType.EvtTaxFormCanceled;
    case 2031:
    case 'tax_form.pdf_ready':
      return EventType.EvtTaxFormPDFdReady;
    case 2041:
    case 'crypto.incoming_transfer.initiated':
      return EventType.EvtCryptoIncomingTransferInitiated;
    case 2042:
    case 'crypto.incoming_transfer.completed':
      return EventType.EvtCryptoIncomingTransferCompleted;
    case 2043:
    case 'crypto.incoming_transfer.counterparty_resolved':
      return EventType.EvtCryptoIncomingTransferCounterpartyResolved;
    case 2044:
    case 'crypto.incoming_transfer.returned':
      return EventType.EvtCryptoIncomingTransferReturned;
    case 2045:
    case 'crypto.incoming_transfer.detected':
      return EventType.EvtCryptoIncomingTransferDetected;
    case 2046:
    case 'crypto.incoming_transfer.manual_review':
      return EventType.EvtCryptoIncomingTransferManualReview;
    case 2047:
    case 'crypto.outgoing_transfer.initiated':
      return EventType.EvtCryptoOutgoingTransferInitiated;
    case 2048:
    case 'crypto.outgoing_transfer.submitted':
      return EventType.EvtCryptoOutgoingTransferSubmitted;
    case 2049:
    case 'crypto.outgoing_transfer.completed':
      return EventType.EvtCryptoOutgoingTransferCompleted;
    case 2050:
    case 'crypto.outgoing_transfer.returned':
      return EventType.EvtCryptoOutgoingTransferReturned;
    case 2051:
    case 'crypto.outgoing_transfer.manual_review':
      return EventType.EvtCryptoOutgoingTransferManualReview;
    case 2052:
    case 'crypto.outgoing_transfer.manual_review_approved':
      return EventType.EvtCryptoOutgoingTransferManualReviewApproved;
    case 2053:
    case 'crypto.incoming_transfer.removed':
      return EventType.EvtCryptoIncomingTransferRemoved;
    case 2054:
    case 'crypto.incoming_transfer.pii_received':
      return EventType.EvtCryptoIncomingTransferPIIReceived;
    case 2061:
    case 'ach_transfer_batch.validated':
      return EventType.EvtACHTransferBatchValidated;
    case 2062:
    case 'ach_transfer_batch.processing':
      return EventType.EvtACHTransferBatchProcessing;
    case 2063:
    case 'ach_transfer_batch.completed':
      return EventType.EvtACHTransferBatchCompleted;
    case 2064:
    case 'ach_transfer_batch.failed':
      return EventType.EvtACHTransferBatchFailed;
    case 2065:
    case 'ach_transfer_batch.expired':
      return EventType.EvtACHTransferBatchExpired;
    case 2071:
    case 'check_issuance_batch.validated':
      return EventType.EvtCheckIssuanceBatchValidated;
    case 2072:
    case 'check_issuance_batch.processing':
      return EventType.EvtCheckIssuanceBatchProcessing;
    case 2073:
    case 'check_issuance_batch.completed':
      return EventType.EvtCheckIssuanceBatchCompleted;
    case 2074:
    case 'check_issuance_batch.failed':
      return EventType.EvtCheckIssuanceBatchFailed;
    case 2075:
    case 'check_issuance_batch.expired':
      return EventType.EvtCheckIssuanceBatchExpired;
    case 3001:
    case 'issuing.card_transaction.created':
      return EventType.EvtIssuingCardTransactionCreated;
    case 3002:
    case 'issuing.card_transaction.updated':
      return EventType.EvtIssuingCardTransactionUpdated;
    case 3025:
    case 'issuing.card_transaction.transaction_data_updated':
      return EventType.EvtIssuingCardTransactionTransactionDataUpdated;
    case 3027:
    case 'issuing.card_dispute.created':
      return EventType.EvtIssuingCardDisputeCreated;
    case 3028:
    case 'issuing.card_dispute.updated':
      return EventType.EvtIssuingCardDisputeUpdated;
    case 3003:
    case 'issuing.3ds.authentication_completed':
      return EventType.EvtIssuing3DSAuthenticationCompleted;
    case 3004:
    case 'issuing.3ds.otp_generated':
      return EventType.EvtIssuing3DSOTPGenerated;
    case 3005:
    case 'issuing.card.created':
      return EventType.EvtIssuingCardCreated;
    case 3006:
    case 'issuing.card.activated':
      return EventType.EvtIssuingCardActivated;
    case 3007:
    case 'issuing.card.paused':
      return EventType.EvtIssuingCardPaused;
    case 3008:
    case 'issuing.card.inactive':
      return EventType.EvtIssuingCardInactive;
    case 3009:
    case 'issuing.card_token.created':
      return EventType.EvtIssuingCardTokenCreated;
    case 3010:
    case 'issuing.card_token.activated':
      return EventType.EvtIssuingCardTokenActivated;
    case 3011:
    case 'issuing.card_token.paused':
      return EventType.EvtIssuingCardTokenPaused;
    case 3012:
    case 'issuing.card_token.deactivated':
      return EventType.EvtIssuingCardTokenDeactivated;
    case 3013:
    case 'issuing.card_token.pending_activation':
      return EventType.EvtIssuingCardTokenPendingActivation;
    case 3014:
    case 'issuing.card_token.activation_denied':
      return EventType.EvtIssuingCardTokenActivationDenied;
    case 3015:
    case 'issuing.card_token.card_changed':
      return EventType.EvtIssuingCardTokenCardChanged;
    case 3016:
    case 'issuing.card_token.send_passcode':
      return EventType.EvtIssuingCardTokenSendPasscode;
    case 3017:
    case 'issuing.card_token.step_up':
      return EventType.EvtIssuingCardTokenStepUp;
    case 3018:
    case 'issuing.card_token.pending_authentication':
      return EventType.EvtIssuingCardTokenPendingAuthentication;
    case 3019:
    case 'issuing.card_token.device_binding.send_passcode':
      return EventType.EvtIssuingCardTokenDeviceBindingSendPasscode;
    case 3020:
    case 'issuing.card_token.device_binding.step_up':
      return EventType.EvtIssuingCardTokenDeviceBindingStepUp;
    case 3021:
    case 'issuing.card_token.device_binding.pending_authentication':
      return EventType.EvtIssuingCardTokenDeviceBindingPendingAuthentication;
    case 3022:
    case 'decision.issuing.card_transaction':
      return EventType.EvtDecisionIssuingCardTransaction;
    case 3023:
    case 'decision.issuing.card_token':
      return EventType.EvtDecisionIssuingCardToken;
    case 3024:
    case 'decision.issuing.card_token.device_binding':
      return EventType.EvtDecisionIssuingCardTokenDeviceBinding;
    case 3026:
    case 'issuing.card_account.created':
      return EventType.EvtIssuingCardAccountCreated;
    case 3029:
    case 'issuing.card_reveal_token.created':
      return EventType.EvtIssuingCardRevealTokenCreated;
    case 3030:
    case 'issuing.card_reveal_token.consumed':
      return EventType.EvtIssuingCardRevealTokenConsumed;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return EventType.UNRECOGNIZED;
  }
};
